import React from 'react';

export const disclaimerInfo = i18n => (
  <div white-space="pre">
    {i18n.getString(_TL_('This is a campaign-level disclaimer that will only serve in your Native ads.'))}
  </div>
);

